export default function Icons() {
	return (
		<svg
			width="0"
			height="0"
			aria-hidden="true"
			style={{ position: 'absolute', left: '-10000px' }}
		>
			{/* Arrow right */}
			<symbol id="arrow-right" viewBox="0 0 13 13">
				<path d="M6.702.348 12.854 6.5l-6.152 6.152-.99-.99L10.874 6.5 5.712 1.338z" />
				<path d="M11.2 5.8v1.4H-.7V5.8z" />
			</symbol>
			{/* Chevron */}
			<symbol id="chevron" viewBox="0 0 10 6">
				<path
					d="M8.521 1.3355 4.9856 4.8711 1.45 1.3355"
					strokeWidth="1.6"
					fill="none"
					strokeMiterlimit="10"
				/>
			</symbol>

			{/* Close */}
			<symbol id="close" viewBox="0 0 18 18">
				<g
					fill="none"
					fillRule="evenodd"
					strokeLinecap="square"
					stroke="#000"
					strokeWidth="1.8"
				>
					<path d="m16.4583 16.4583-15-15M1.4583 16.4583l15-15" />
				</g>
			</symbol>

			{/* Plus */}
			<symbol id="plus" viewBox="0 0 28 28">
				<path
					d="M28 14H0M14 0v28"
					stroke="#000"
					strokeWidth="2"
					fill="none"
					strokeMiterlimit="10"
				/>
			</symbol>

			{/* Search */}
			<symbol id="search" viewBox="0 0 26 26" width="26" height="26">
				<defs>
					<clipPath id="search-cp">
						<path d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Z" />
					</clipPath>
				</defs>
				<g clipPath="url(#search-cp)" transform="translate(.5)">
					<path
						d="M12 24c6.6274 0 12-5.3726 12-12S18.6274 0 12 0 0 5.3726 0 12s5.3726 12 12 12Z"
						stroke="#000"
						strokeWidth="6.6"
						fill="none"
						strokeMiterlimit="5"
					/>
				</g>
				<path
					d="m19 19.5 6 6"
					stroke="#000"
					strokeWidth="3.3"
					fill="none"
					strokeMiterlimit="10"
				/>
			</symbol>

			{/* Twitter */}
			<symbol id="twitter">
				<defs>
					<clipPath id="twitter-cp">
						<path d="M11.0773 0c.944 0 1.798.3974 2.396 1.0333a6.5886 6.5886 0 0 0 2.0847-.794c-.2447.7641-.7653 1.4054-1.4433 1.81A6.5703 6.5703 0 0 0 16 1.5344a6.6712 6.6712 0 0 1-1.638 1.694c.208 4.6018-3.2353 9.7325-9.33 9.7325-1.8533 0-3.5793-.5416-5.032-1.4699 1.7413.2047 3.48-.277 4.86-1.3556-1.4373-.0266-2.6493-.9722-3.0667-2.272a3.3005 3.3005 0 0 0 1.4827-.0558C1.6973 7.4918.6073 6.0737.6433 4.558c.442.2452.9487.392 1.486.4093C.668 3.9931.254 2.0693 1.114.5987 2.7333 2.5783 5.152 3.8808 7.8793 4.017 7.4007 1.971 8.958 0 11.0773 0Z" />
					</clipPath>
				</defs>
				<g clipPath="url(#twitter-cp)">
					<path d="M0 0h16v12.9608H0V0z" />
				</g>
			</symbol>

			{/* Facebook */}
			<symbol id="facebook">
				<defs>
					<clipPath id="facebook-cp">
						<path d="M8.4976 0v2.8832h-2.046c-.2026 0-.3913.072-.5618.214-.169.142-.256.277-.256.4024v1.7938h2.863c-.03.3511-.0629.6926-.101 1.0222l-.1133.8713a32.401 32.401 0 0 1-.1368.8186H5.6133v7.9938h-3.773V8.0048H0V5.2934h1.8404V3.0875c0-.0997.0146-.3151.0439-.6448.0314-.3303.1631-.676.3994-1.0388.234-.3616.6137-.6864 1.1418-.9738C3.9515.144 4.7115 0 5.7033 0h2.7943Z" />
					</clipPath>
				</defs>
				<g clipPath="url(#facebook-cp)">
					<path d="M0 0h8.4976v15.9993H0V0z" />
				</g>
			</symbol>

			{/* Instagram */}
			<symbol id="instagram">
				<defs>
					<clipPath id="instagram-cp">
						<path d="M8.4133.0009c1.2289.003 1.5181.014 2.179.0442.7982.0364 1.3434.1632 1.8205.3487.4932.1916.9114.448 1.3284.865.417.417.6734.8352.865 1.3284.1855.477.3123 1.0223.3487 1.8206.0301.6608.0413.95.0442 2.1789L15 7.2442 15 7.5v.1304l-.0009.783c-.003 1.2288-.014 1.518-.0442 2.1788-.0364.7983-.1632 1.3435-.3486 1.8206-.1917.4932-.4481.9114-.865 1.3284-.417.417-.8353.6734-1.3285.865-.477.1855-1.0223.3123-1.8206.3487-.6608.0301-.95.0413-2.1789.0442L7.7558 15 7.5 15h-.1303l-.783-.0009c-1.2289-.003-1.5181-.014-2.179-.0442-.7982-.0364-1.3434-.1632-1.8205-.3486-.4932-.1917-.9114-.4481-1.3284-.865-.417-.417-.6734-.8353-.865-1.3285-.1855-.477-.3123-1.0223-.3487-1.8206-.0301-.6608-.0413-.95-.0442-2.1789V6.5867c.003-1.2289.014-1.5181.0442-2.179.0364-.7982.1632-1.3434.3487-1.8205.1916-.4932.448-.9114.865-1.3284.417-.417.8352-.6734 1.3284-.865C3.0642.2083 3.6095.0815 4.4078.045c.6608-.0301.95-.0413 2.1789-.0442h1.8266Zm-.2146 1.3509H6.8013c-.8939.0013-1.3204.006-1.6983.0177l-.1725.0059a56.498 56.498 0 0 0-.4611.0197c-.7313.0333-1.1284.1555-1.3927.2582-.35.136-.6.2986-.8623.561-.2625.2625-.425.5123-.561.8624-.1028.2643-.225.6614-.2583 1.3927a56.498 56.498 0 0 0-.0197.461l-.006.1726c-.0116.3779-.0163.8044-.0176 1.6983v1.3974c.0013.8939.006 1.3204.0177 1.6983l.0059.1725c.0053.1435.0118.2892.0197.4611.0333.7313.1555 1.1284.2582 1.3927.136.35.2986.6.561.8623.2625.2625.5123.425.8624.561.2643.1028.6614.225 1.3927.2583.1719.0079.3176.0144.461.0197l.1725.006c.3779.0116.8044.0163 1.6984.0176h1.3974c.894-.0013 1.3205-.006 1.6984-.0177l.1725-.0059c.1434-.0053.2891-.0118.461-.0197.7313-.0333 1.1284-.1555 1.3927-.2582.35-.136.6-.2986.8623-.561.2625-.2625.425-.5123.561-.8624.1028-.2643.225-.6614.2583-1.3927.0079-.1719.0144-.3176.0197-.461l.006-.1726c.0116-.3779.0163-.8044.0176-1.6983V6.8013c-.0013-.8939-.006-1.3204-.0177-1.6983l-.0059-.1725a56.494 56.494 0 0 0-.0197-.4611c-.0333-.7313-.1555-1.1284-.2582-1.3927-.136-.35-.2986-.6-.561-.8623-.2625-.2625-.5123-.425-.8624-.561-.2643-.1028-.6614-.225-1.3927-.2583a56.4986 56.4986 0 0 0-.461-.0197l-.1726-.006c-.3779-.0116-.8044-.0163-1.6983-.0176ZM7.5 3.6487c2.127 0 3.8513 1.7242 3.8513 3.8513 0 2.127-1.7242 3.8513-3.8513 3.8513-2.127 0-3.8513-1.7242-3.8513-3.8513 0-2.127 1.7242-3.8513 3.8513-3.8513ZM7.5 5C6.1193 5 5 6.1193 5 7.5S6.1193 10 7.5 10 10 8.8807 10 7.5 8.8807 5 7.5 5Zm4.0035-2.4035a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z" />
					</clipPath>
				</defs>
				<g clipPath="url(#instagram-cp)" transform="translate(.5 .5)">
					<path d="M.0009.0009H15V15H.0009V.0009z" />
				</g>
				<path
					d="M8.9133.5009c1.2289.003 1.5181.014 2.179.0442.7982.0364 1.3434.1632 1.8205.3487.4932.1916.9114.448 1.3284.865.417.417.6734.8352.865 1.3284.1855.477.3123 1.0223.3487 1.8206.0301.6608.0413.95.0442 2.1789l.0008.6575L15.5 8v.2558l-.0009.6575c-.003 1.2289-.014 1.5181-.0442 2.179-.0364.7982-.1632 1.3434-.3486 1.8205-.1917.4932-.4481.9114-.865 1.3284-.417.417-.8353.6734-1.3285.865-.477.1855-1.0223.3123-1.8206.3487-.6608.0301-.95.0413-2.1789.0442l-.6575.0008L8 15.5h-.2558l-.6575-.0009c-1.2289-.003-1.5181-.014-2.179-.0442-.7982-.0364-1.3434-.1632-1.8205-.3486-.4932-.1917-.9114-.4481-1.3284-.865-.417-.417-.6734-.8353-.865-1.3285-.1855-.477-.3123-1.0223-.3487-1.8206-.0301-.6608-.0413-.95-.0442-2.1789V7.0867c.003-1.2289.014-1.5181.0442-2.179.0364-.7982.1632-1.3434.3487-1.8205.1916-.4932.448-.9114.865-1.3284.417-.417.8352-.6734 1.3284-.865C3.5642.7083 4.1095.5815 4.9078.545c.6608-.0301.95-.0413 2.1789-.0442Zm-.2146 1.3509H7.3013c-.8939.0013-1.3204.006-1.6983.0177l-.1725.0059a56.498 56.498 0 0 0-.4611.0197c-.7313.0333-1.1284.1555-1.3927.2582-.35.136-.6.2986-.8623.561-.2625.2625-.425.5123-.561.8624-.1028.2643-.225.6614-.2583 1.3927a56.498 56.498 0 0 0-.0197.461l-.006.1726c-.0116.3779-.0163.8044-.0176 1.6983v1.3974c.0013.8939.006 1.3204.0177 1.6983l.0059.1725c.0053.1435.0118.2892.0197.4611.0333.7313.1555 1.1284.2582 1.3927.136.35.2986.6.561.8623.2625.2625.5123.425.8624.561.2643.1028.6614.225 1.3927.2583.1719.0079.3176.0144.461.0197l.1725.006c.3779.0116.8044.0163 1.6984.0176h1.3974c.894-.0013 1.3205-.006 1.6984-.0177l.1725-.0059c.1434-.0053.2891-.0118.461-.0197.7313-.0333 1.1284-.1555 1.3927-.2582.35-.136.6-.2986.8623-.561.2625-.2625.425-.5123.561-.8624.1028-.2643.225-.6614.2583-1.3927.0079-.1719.0144-.3176.0197-.461l.006-.1726c.0116-.3779.0163-.8044.0176-1.6983V7.3013c-.0013-.8939-.006-1.3204-.0177-1.6983l-.0059-.1725a56.494 56.494 0 0 0-.0197-.4611c-.0333-.7313-.1555-1.1284-.2582-1.3927-.136-.35-.2986-.6-.561-.8623-.2625-.2625-.5123-.425-.8624-.561-.2643-.1028-.6614-.225-1.3927-.2583a56.4986 56.4986 0 0 0-.461-.0197l-.1726-.006c-.3779-.0116-.8044-.0163-1.6983-.0176ZM8 4.1487c2.127 0 3.8513 1.7242 3.8513 3.8513 0 2.127-1.7242 3.8513-3.8513 3.8513-2.127 0-3.8513-1.7242-3.8513-3.8513 0-2.127 1.7242-3.8513 3.8513-3.8513ZM8 5.5C6.6193 5.5 5.5 6.6193 5.5 8s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5S9.3807 5.5 8 5.5Zm4.0035-2.4035a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z"
					stroke="#000"
					strokeWidth=".5"
					fill="none"
					strokeMiterlimit="10"
				/>
			</symbol>

			{/* Vimeo */}
			<symbol id="vimeo">
				<defs>
					<clipPath id="vimeo-cp">
						<path d="M12.987.0608c.8418-.1315 2.0706-.104 2.6478.641.4139.5312.4165 1.2337.297 1.9168-.184.9875-1.4019 4.4422-3.6094 7.4918-.9654 1.2887-2.0933 2.5552-3.5409 3.4287-.5343.3233-1.5898.73-2.292.426-1.3763-.5944-1.8651-3.0208-2.2627-4.6448-.235-.9587-.4565-1.8665-.7438-2.7003-.2147-.626-.3196-1.2626-.6553-1.8433-.5518-.9503-1.3427-.0369-2.1726-.1615-.3518-.052-.4162-.434-.6551-.667v-.0916C1.2057 2.876 2.2678 1.6876 3.6615.8524c.4378-.263 1.1832-.545 1.786-.3644.5613.1671 1.0203.938 1.2205 1.5776.2323.7435.3573 1.6445.4754 2.3675.212 1.2885.1424 3.2234 1.0701 4.2353 1.03 1.1241 1.8153-.4355 2.2343-1.2297.3627-.6889.6876-1.4077.744-2.0636.1343-1.5678-.5976-1.7786-1.994-1.6705C9.986 1.2097 12.3023.1676 12.987.0608Z" />
					</clipPath>
				</defs>
				<g clipPath="url(#vimeo-cp)">
					<path d="M0 0h16v14.0722H0V0z" />
				</g>
			</symbol>

			{/* Info */}
			<symbol id="info">
				<g fill="none" fillRule="evenodd">
					<circle
						stroke="#000"
						strokeWidth="1.5"
						cx="8"
						cy="8"
						r="7.25"
					/>
					<circle fill="#000" cx="8" cy="4.5" r="1" />
					<path stroke="#000" strokeWidth="1.5" d="M8 6.5v6" />
				</g>
			</symbol>

			{/* Warning */}
			<symbol id="warning">
				<g fill="none" fillRule="evenodd">
					<path
						d="M8.396 1.439A2.25 2.25 0 0 1 10.96 2.5l5.863 10.394c.305.54.362 1.154.208 1.709a2.243 2.243 0 0 1-2.168 1.646H3.137a2.243 2.243 0 0 1-1.591-.659 2.243 2.243 0 0 1-.369-2.696L7.04 2.5a2.243 2.243 0 0 1 1.356-1.062Z"
						stroke="#000"
						strokeWidth="1.5"
					/>
					<g transform="translate(8 5)">
						<circle fill="#000" cx="1" cy="1" r="1" />
						<path stroke="#000" strokeWidth="1.5" d="M1 3v6" />
					</g>
				</g>
			</symbol>

			{/* Cart White */}
			<symbol id="cart-white">
				<g
					fill="none"
					fillRule="evenodd"
					stroke="#FFF"
					strokeWidth="1.4"
				>
					<path d="m13.664 4.7 1.314 9.115a1.296 1.296 0 0 1-1.058 1.465L2.31 15.3a1.296 1.296 0 0 1-1.3-1.256L2.339 4.7h11.326Z" />
					<path d="M5.3 7.5v-4a2.7 2.7 0 0 1 5.4 0v4" />
				</g>
			</symbol>

			{/* Cart Black */}
			<symbol id="cart-black">
				<g
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeWidth="1.4"
				>
					<path d="m13.664 4.7 1.314 9.115a1.296 1.296 0 0 1-1.058 1.465L2.31 15.3a1.296 1.296 0 0 1-1.3-1.256L2.339 4.7h11.326Z" />
					<path d="M5.3 7.5v-4a2.7 2.7 0 0 1 5.4 0v4" />
				</g>
			</symbol>
		</svg>
	);
}
